import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectPage, selectPageExtra } from '../../../selectors/analytics';
import {
  selectFormAdditionalServices,
  selectFormPriceRange,
  selectFormRoomCount,
} from '../../../selectors/requestFormV2';
import { trackFinishSurvey } from '../../../utils/analytics/trackFinishSurvey';

export function useQuizAnalytics(): () => void {
  const page = useSelector(selectPage);
  const extra = useSelector(selectPageExtra);
  const additionalServicesValue = useSelector(selectFormAdditionalServices);
  const priceRangeValue = useSelector(selectFormPriceRange);
  const roomCountValue = useSelector(selectFormRoomCount);

  const pageWithExtra = React.useMemo(() => {
    return {
      ...page,
      extra: {
        ...extra,
        kpn_survey: {
          rooms: roomCountValue,
          budget: priceRangeValue,
          documents_help: additionalServicesValue,
        },
      },
    };
  }, [page, extra, roomCountValue, priceRangeValue, additionalServicesValue]);

  return () => trackFinishSurvey(pageWithExtra);
}
